import React from "react";
import "./about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component
import { Box, Typography } from "@mui/material";

const FutureScope = () => {
  const sections = [
    {
      image: "Images/About/fs1.png",
      text: "JAMIA NIDA-E-ISLAM envisions a future that is dynamic, progressive, and impactful, where the institution continues to evolve and grow in alignment with its core mission of providing transformative education and fostering a sense of social responsibility. As part of its ongoing development, the school has laid out an ambitious roadmap to expand its reach and enhance the quality of education it offers.",
    },
    {
      image: "Images/About/fs2.png",
      text: "A key aspect of JAMIA NIDA-E-ISLAM’s future is the continuous upgrade of its educational infrastructure. The school aims to build state-of-the-art classrooms, laboratories, and learning spaces equipped with the latest technology to facilitate interactive learning. The development of a modern library, multipurpose halls, and outdoor spaces will further enhance the overall student experience.",
    },
    {
      image: "Images/About/fs3.png",
      text: "In addition to physical development, JAMIA NIDA-E-ISLAM is committed to continuously innovating its curriculum to stay at the forefront of educational trends. The school plans to introduce specialized programs in fields providing students with more opportunities to explore their interests and talents.",
    },
    {
      image: "Images/About/fs4.png",
      text: "The school’s dedication to social service will continue to be a cornerstone of its mission. Future plans include expanding community outreach programs and partnerships with local charities, non-profits, and other organizations to provide more opportunities for students to engage in service learning.",
    },
    {
      image: "Images/About/fs5.png",
      text: "JAMIA NIDA-E-ISLAM’s future is one of growth, innovation, and impact. As the institution continues to develop, it remains steadfast in its commitment to providing high-quality education while nurturing values of empathy, integrity, and social responsibility.",
    },
  ];

  return (
    <div className="about-education">
      <Header />
      <main className="content">
        {/* Hero Section */}
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Background"
            className="hero-image"
          />
          <div className="overlay">
            <h1 className="title">
              Future<br />Plans
            </h1>
          </div>
        </section>

        {/* Content Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "16px",
            marginLeft: { xs: "auto", md: "50px" },
            marginRight: { xs: "auto", md: "50px" },
          }}
        >
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: index % 2 === 0 ? "row" : "row-reverse",
                },
                gap: 3,
                alignItems: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box
                component="img"
                src={section.image}
                alt={`Section ${index}`}
                sx={{
                  flex: 1,
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  maxWidth: { md: "25%" },
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  flex: 1,
                  fontSize: "1.1rem",
                  textAlign: "justify",
                  color: "#555",
                }}
              >
                {section.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </main>
      <Footer />
    </div>
  );
};

export default FutureScope;
